import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import theme from '../../configs/theme';
import socket from '../../socket';
import { getUser } from "../../auth"

const URL = process.env.REACT_APP_API_URL;

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Filler, Tooltip, Legend);

export default function VentasChart({ height, width }) {
  const [chartData, setChartData] = useState(null);

  const fetchChart = () => {
    const user = getUser()
    fetch(`${URL}/api/sales/summary/last-3-days/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error('Error al obtener resumen de ventas');
        return res.json();
      })
      .then((data) => {
        const labels = data.map(item => item.date);
        const totals = data.map(item => item.total);
        
        setChartData({
          labels,
          datasets: [
            {
              label: 'Total ventas',
              data: totals,
              borderColor: theme.colors.primary,
              backgroundColor: theme.colors.secondary,
              fill: true,
              pointRadius: 5,
              pointHoverRadius: 15,
            },
          ],
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchChart();
  }, []);

  useEffect(() => {
    socket.on("venta_creada", () => fetchChart());
    socket.on("venta_borrada", () => fetchChart());
    socket.on("venta_editada", () => fetchChart());

    return () => {
      socket.off("venta_creada");
      socket.off("venta_borrada");
      socket.off("venta_editada");
    };
  }, []);

  if (!chartData) return <Typography variant="body2" sx={{ p: 2 }}>Cargando gráfico...</Typography>;

  return (
    <Box sx={{ p: 1, height: height, width: width }}>
      <Typography variant="h6" fontWeight="bold" color="white" gutterBottom>
        Ventas últimos 3 días
      </Typography>
      <Line 
        data={chartData}
        options={{
          scales: {
            x: {
              ticks: {
                color: '#ccc'  // gris claro
              },
              grid: {
                color: '#444'     // opcional: líneas de la grilla
              }
            },
            y: {
              ticks: {
                color: '#ccc'
              },
              grid: {
                color: '#444'
              }
            },
            //min: 0,
            //max: 1000000,
          },
          plugins: {
            legend: {
              labels: {
                color: '#fff'
              }
            }
          }
        }} 
      />
    </Box>
  );
}
